module.exports = __webpack_public_path__ + "static/img/xinjianduihuaIcon.2cb678a5.svg";